import axios from "axios";
import { getEngagementManagerUrls } from "./endpoints/engagementManager";
import { downloadBlob } from "../../util/filterHelpers";

async function post(url, data = null) {
  const res = await axios.post(url, data);
  if (res.status === 200) return res.data;
  throw new Error("Error in response - " + res);
}

export async function fetchMyOrders(filterDto, domain) {
  const urls = getEngagementManagerUrls(domain);
  return await post(urls.MyOrders, filterDto);
}

export async function fetchMyOrdersFilters(payload, domain) {
  const urls = getEngagementManagerUrls(domain);
  return await post(urls.MyOrdersFilters, payload);
}

export async function fetchMyOrdersStatusCounts(payload, domain) {
  const urls = getEngagementManagerUrls(domain);
  return await post(urls.MyOrdersStatusCounts, payload);
}

export async function acknowledgeOrder({
  requestIds,
  engagementManagerEmail,
  domain,
}) {
  const urls = getEngagementManagerUrls(domain);
  return await post(urls.AcknowledgeOrder, {
    requestId: requestIds,
    engagementManagerEmail,
  });
}

export async function exportMyOrders(filterDto, domain) {
  const urls = getEngagementManagerUrls(domain);
  const res = await axios.post(urls.ExportMyOrders, filterDto, {
    responseType: "blob",
  });
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename[^;=\n]*=["']?([^"';\n]+)/);
  const filename = match?.[1] || "MyOrders.xlsx";
  downloadBlob(res.data, filename);
}

export async function upsertOrderServiceDetails(payload, domain) {
  const urls = getEngagementManagerUrls(domain);
  return await post(urls.UpsertServiceDetails, payload);
}

export async function upsertOrderRequestComments(requestId, comments, domain) {
  const urls = getEngagementManagerUrls(domain);
  return await post(urls.UpsertOrderRequestComments, {
    requestId,
    comments,
  });
}
